import React from 'react';
//Material-UI
import { IconButton, Button } from '@material-ui/core';
//Icons
import { CirclePlus, CircleMinus } from 'tabler-icons-react';
//Context
import { useProductos } from './ProductosContext';
//Style
import '../../styles/capacitiesDefault.css';

const allowPiezas = process.env.REACT_APP_ALLOW_CAP_PIEZAS !== 'false';
const allowIdeal = process.env.REACT_APP_ALLOW_CAP_VELOCIDAD_IDEAL !== 'false';
const allowEstandar = process.env.REACT_APP_ALLOW_CAP_VELOCIDAD_ESTANDAR !== 'false';
const lineaLenta = process.env.REACT_APP_LINEA_LENTA === 'true';

const setColor = (newColor) => {
    document.documentElement.style.setProperty('--color', newColor);
};

function CapField({ label, helper, value, fieldIndex, isLineSelected, increment, decrement, setCapValue }) {
    return (
        <div className="inputNumb">
            <div className="capacities-bg">
                <p>{label}</p>
            </div>
            <div className="numberField">
                <div className="cap-field-row">
                    <IconButton
                        color="primary"
                        size="small"
                        disabled={isLineSelected}
                        onClick={(e) => decrement(e, fieldIndex)}
                    >
                        <CircleMinus color="#7D7F90" />
                    </IconButton>
                    <input
                        type="number"
                        className="cap-input"
                        value={value}
                        min={0}
                        disabled={isLineSelected}
                        onChange={(e) => setCapValue(fieldIndex, e.target.value)}
                    />
                    <IconButton
                        color="primary"
                        size="small"
                        disabled={isLineSelected}
                        onClick={(e) => increment(e, fieldIndex)}
                    >
                        <CirclePlus color="#7D7F90" />
                    </IconButton>
                </div>
            </div>
            {helper && <div className="helper">{helper}</div>}
        </div>
    );
}

export default function CapacidadesList() {
    const {
        pzas,
        ideal,
        std,
        cnlCap,
        isLineSelected,
        isSaveCap,
        saveCapacities,
        increment,
        decrement,
        setCapValue,
        selectedLine,
    } = useProductos();

    let primColor = '';
    if (process.env.REACT_APP_THEME === 'tecnoTheme') {
        primColor = '#ff9800';
        setColor(primColor);
    } else if (process.env.REACT_APP_THEME === 'colTheme') {
        primColor = '#58ab01';
        setColor(primColor);
    } else if (process.env.REACT_APP_THEME === 'matteTheme') {
        primColor = '#253139';
        setColor(primColor);
    } else if (process.env.REACT_APP_THEME === 'skyTheme') {
        primColor = '#001B69';
        setColor(primColor);
    } else if (process.env.REACT_APP_THEME === 'posTheme') {
        primColor = '#00638D';
        setColor(primColor);
    } else if (process.env.REACT_APP_THEME === 'vaisandTheme') {
        primColor = '#1959D9';
        setColor(primColor);
    } else {
        primColor = '#903bff';
        setColor(primColor);
    }

    return (
        <div className="productos-panel-cap">
            <div className="productos-card">
                <div className="productos-card-toolbar">
                    <h3 className="productos-card-title">Capacidades</h3>
                </div>
                {selectedLine === 0 ? (
                    <div className="productos-empty">
                        Selecciona una línea para ver sus capacidades
                    </div>
                ) : (
                    <div key={selectedLine} className="productos-cap-animate">
                        <div className="productos-cap-body">
                            {allowPiezas && (
                                <CapField
                                    label="PIEZAS POR PAQUETE"
                                    value={pzas}
                                    fieldIndex={0}
                                    isLineSelected={isLineSelected}
                                    increment={increment}
                                    decrement={decrement}
                                    setCapValue={setCapValue}
                                />
                            )}
                            {allowIdeal && (
                                <CapField
                                    label={lineaLenta ? 'Tiempo Ideal' : 'Velocidad Ideal'}
                                    helper={lineaLenta ? 'Minutos por pieza' : 'Piezas / Minuto'}
                                    value={ideal}
                                    fieldIndex={1}
                                    isLineSelected={isLineSelected}
                                    increment={increment}
                                    decrement={decrement}
                                    setCapValue={setCapValue}
                                />
                            )}
                            {allowEstandar && (
                                <CapField
                                    label={lineaLenta ? 'Tiempo Estándar' : 'Velocidad Estándar'}
                                    helper={lineaLenta ? 'Minutos por pieza' : 'Piezas / Minuto'}
                                    value={std}
                                    fieldIndex={2}
                                    isLineSelected={isLineSelected}
                                    increment={increment}
                                    decrement={decrement}
                                    setCapValue={setCapValue}
                                />
                            )}
                        </div>
                        <div className="productos-panel-footer">
                            <Button
                                variant="outlined"
                                className="productos-btn"
                                onClick={cnlCap}
                                disabled={isLineSelected}
                            >
                                Cancelar
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                className="productos-btn"
                                disabled={isSaveCap}
                                onClick={saveCapacities}
                            >
                                Guardar
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
